var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0578 18.1508C18.9963 18.1508 18.9357 18.1397 18.8762 18.1175L5.76131 13.0733C5.5666 12.9986 5.43848 12.811 5.43848 12.6021V6.54911C5.43848 6.34028 5.5666 6.15263 5.76131 6.07798L18.8762 1.03378C19.0326 0.973252 19.2051 0.995446 19.3433 1.08927C19.4805 1.18309 19.5622 1.33845 19.5622 1.50491V17.6463C19.5622 17.8128 19.4805 17.9682 19.3433 18.062C19.2576 18.1205 19.1587 18.1508 19.0578 18.1508ZM6.44732 12.2551L18.5534 16.9119V2.23935L6.44732 6.89615V12.2551Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94217 13.1048H2.41123C1.29848 13.1048 0.393555 12.1999 0.393555 11.0872V8.06065C0.393555 6.9479 1.29848 6.04297 2.41123 6.04297H5.94217C6.22061 6.04297 6.44659 6.26895 6.44659 6.54739V12.6004C6.44659 12.8789 6.22061 13.1048 5.94217 13.1048ZM2.41123 7.05181C1.85435 7.05181 1.40239 7.50377 1.40239 8.06065V11.0872C1.40239 11.644 1.85435 12.096 2.41123 12.096H5.43775V7.05181H2.41123Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9588 20.1703H4.93228C4.68108 20.1703 4.46821 19.9857 4.4329 19.7365L3.42406 12.6746C3.38472 12.3992 3.5764 12.144 3.85282 12.1046C4.12319 12.0703 4.38347 12.257 4.42282 12.5334L5.37012 19.1615H7.39385L6.71994 13.1548C6.68968 12.8784 6.88842 12.6292 7.16484 12.597C7.43218 12.5677 7.69044 12.7654 7.72273 13.0419L8.45918 19.6094C8.47532 19.7527 8.42992 19.8949 8.33408 20.0018C8.23925 20.1088 8.10306 20.1703 7.9588 20.1703Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0756 7.05456C20.9132 7.05456 20.7538 6.97588 20.6559 6.82959C20.5016 6.59857 20.5641 6.28482 20.7962 6.13047L23.8227 4.11279C24.0527 3.95945 24.3665 4.01998 24.5218 4.25302C24.6762 4.48404 24.6136 4.79779 24.3816 4.95214L21.3551 6.96982C21.2693 7.02733 21.1725 7.05456 21.0756 7.05456Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1019 16.1324C24.005 16.1324 23.9082 16.1052 23.8224 16.0477L20.7959 14.03C20.5649 13.8757 20.5013 13.5619 20.6557 13.3309C20.811 13.0988 21.1258 13.0373 21.3548 13.1907L24.3813 15.2083C24.6123 15.3627 24.6759 15.6764 24.5216 15.9075C24.4237 16.0537 24.2643 16.1324 24.1019 16.1324Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1022 10.584H21.0757C20.7973 10.584 20.5713 10.3581 20.5713 10.0796C20.5713 9.80118 20.7973 9.5752 21.0757 9.5752H24.1022C24.3807 9.5752 24.6066 9.80118 24.6066 10.0796C24.6066 10.3581 24.3807 10.584 24.1022 10.584Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotices);
export default __webpack_public_path__ + "static/media/Notices.1667991a0ffcbd90dc3881c456f5ea80.svg";
export { ForwardRef as ReactComponent };